import { useEffect, useState } from 'react';

import type { BreakPoint } from '@/common/hooks/useBreakPoint';
import { useBreakPoint } from '@/common/hooks/useBreakPoint';

export const NoGroupsMatch = 'NoGroupsMatch';
export type NoGroupsMatchType = typeof NoGroupsMatch;
type BreakPointGroups = Record<string, BreakPoint[]>;

function getCurrentBreakPointGroupKey<T extends BreakPointGroups>(
  groups: T,
  currentBreakpoint: BreakPoint
): keyof T | NoGroupsMatchType {
  if (!groups) {
    return NoGroupsMatch;
  }
  for (const [key, breakPointGroup] of Object.entries(groups)) {
    if (breakPointGroup.includes(currentBreakpoint)) {
      return key;
    }
  }
  return NoGroupsMatch;
}

export function useBreakPointGroups<T extends BreakPointGroups>(
  groups: T
): keyof T | NoGroupsMatchType {
  const currentBreakpoint = useBreakPoint();
  const [breakPointGroupKey, setBreakPointGroupKey] = useState<
    keyof T | NoGroupsMatchType
  >(getCurrentBreakPointGroupKey(groups, currentBreakpoint));

  useEffect(() => {
    setBreakPointGroupKey(
      getCurrentBreakPointGroupKey(groups, currentBreakpoint)
    );
  }, [groups, currentBreakpoint]);

  return breakPointGroupKey;
}
